import { isValidElement, ReactNode } from "react";

import { Icon, IconData } from "./Icon";

export const isIconData = (icon: IconData | ReactNode): boolean => {
  if (icon === null) {
    return false;
  }
  if (isValidElement(icon)) {
    return false;
  }

  if (typeof icon === "object" && "$$typeof" in icon && "render" in icon) {
    return true;
  }

  return false;
};

export const asIcon = (icon: IconData | ReactNode, Cls = Icon): ReactNode => {
  if (!icon) {
    return null;
  }
  if (isIconData(icon)) {
    return <Cls icon={icon as IconData} />;
  }
  return icon as ReactNode;
};
